import { Draft, PayloadAction }      from '@reduxjs/toolkit';
import { IOrganisationInvoiceState } from 'Redux/Slices/OrganisationInvoice/OrganisationInvoiceSlice';
import { OrganisationInvoice }       from 'Domain/Models';
import { PayloadActionList }         from 'Utils';
import { removeActionTypes }         from 'Utils/ReducerUtility';


export const findOrganisationInvoicesRequest = (state: Draft<IOrganisationInvoiceState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findOrganisationInvoicesSuccess = (state: Draft<IOrganisationInvoiceState>, { type, payload }: PayloadAction<{
  organisationInvoices: Record<string, OrganisationInvoice>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.organisationInvoices;
  state.maxCount = payload.maxCount || state.maxCount;

};

export const findOrganisationInvoicesFailure = (state: Draft<IOrganisationInvoiceState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
